import { observer } from "mobx-react-lite"
import Value from "pages/content/store/value"
import { useState } from "react"
import Tooltip from "../tooltip"
import { InputWrapper, InputComponent, InputLabel } from "./styled"

type Props = {
  label?: string,
  placeholder?: string,
  value: Value,
  defaultValue?: string
  tooltip?: string,
  disabled?: boolean,
  type?: string
}

const regexp = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/gi

const ContentInput = observer(({ label, value, placeholder, defaultValue, tooltip, disabled, type }: Props) => {
  
  const [ error, setError ] = useState(false)
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError(false)
    if (type === "number") {
      return value.set(e.target.value.replace(/[^\d.,]/g,''))
    }
    value.set(e.target.value)
  }

  const onBlur = () => {
    if (type === "link" && value.value) {
      setError(!(new RegExp(regexp).test(value.value)))
    }
  }

  return (
    <InputWrapper disabled={disabled}>
      <InputLabel>
        { label }
        <Tooltip title={tooltip} />
      </InputLabel>
      <InputComponent 
        placeholder={placeholder} 
        value={value.value} 
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
      />
    </InputWrapper>
  )
})

export default ContentInput